'use strict';

define([], function () {

  var showPasswordToggleComponent = function showPasswordToggleComponent() {
    var component = {};

    var _config = {};

    var _init = function _init(element) {
      component.element = element;
      component.nameType = document.querySelectorAll('[type=password]');
      component.bind();
      return component;
    };

    var _bind = function _bind() {
      component.pwdCheckbox = component.element.querySelector('[type=checkbox]');
      component.pwdCheckbox.addEventListener('change', component.changeType);
    };

    var _changeType = function _changeType(e) {
      var inputType = e.target.checked ? 'text' : 'password';

      Array.from(component.nameType).forEach(function (el) {
        el.type = inputType;
      });
    };

    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.changeType = _changeType;

    return component;
  };

  return showPasswordToggleComponent;
});
//# sourceMappingURL=showPasswordToggleComponent.js.map
